import { useCallback, useEffect, useState } from "react";
import { requestMenuSections } from "../redux/restaurantSlice";

/*
 * One restaurant location's menu, read locally (the storefront's slice keeps
 * whatever storefront it holds). The same read the storefront makes, so each
 * dish comes back as it stands at that branch.
 */
export default function useRestaurantMenuSections({ vendorId, outletId = null, enabled = true }) {
  const [state, setState] = useState({ status: "idle", sections: [] });

  const load = useCallback(() => {
    if (!vendorId) return undefined;
    let active = true;
    setState((current) => ({ ...current, status: "loading" }));
    requestMenuSections({ vendorId, outletId })
      .then((sections) => {
        if (active) setState({ status: "ready", sections: Array.isArray(sections) ? sections : [] });
      })
      .catch(() => {
        if (active) setState({ status: "failed", sections: [] });
      });
    return () => {
      active = false;
    };
  }, [vendorId, outletId]);

  useEffect(() => {
    if (!enabled) return undefined;
    return load();
  }, [enabled, load]);

  return { ...state, retry: load };
}
